<template>
<div>
  <div class='user_wrapper'>
    <div class='user_content'>
      <img :src="userInfo.avatarUrl" class="avatarUrlPic" />
      <span class="userName">{{userInfo.nikeName}}</span>
    </div>
    <div class='publish_btn_wrapper'>
      <span class='publish_btn' @click="send">发布</span>
    </div>
  </div>
  <!--fabiao-->
  <div class="publish_wrapper">
    <div class='publish_textarea'>
      <textarea class="paperContent" placeholder='请开始你的表演...' v-model='paperContent'></textarea>
    </div>
    <div class='upload_img_wrapper'>
      <div class="picItem" v-for="(img,index) in imgs">
        <img :src="gobalUrl+img" class="goods_pic">
        <div class="delete_wrapper" @click="delPic(index)">
          <span class="icon-delete icon_delete_clor"></span>
        </div>
      </div>
      <div class='upload_btn_wrapper' v-if="imgs.length<9">
        <div class='upload_btn'>
          <img src="../../images/upload_btn.png" class="upload_btn_img"></image>
          <div class="upload_btn_text">图片</div>
        </div>
        <input type="file" name="file" class="uploader" @change="selectPics" accept="image/*" multiple />
        <div class="upload_disable" v-show="uploadDisable">
          <span class="upload_prompt">loading...</span>
        </div>
      </div>
    </div>
    <div>
    </div>
  </div>
  <baskCoupons :myCoupons='myCoupons' v-on:selectedCouponParent='selectedCouponParent' v-if="myCoupons.length>0"></baskCoupons>
  <baskWelfare :myWelfares='myWelfares' v-on:selectedWelfareParent='selectedWelfareParent' v-if="myWelfares.length>0"></baskWelfare>
</div>
</template>
<script type = "text/ecamscript-6">
import BaskCoupons from '@/components/quan/baskCoupons'
import BaskWelfare from '@/components/quan/baskWelfare'
import EXIF from 'exif-js'
import {
  Toast
} from 'mint-ui'
import {
  config,
  addScore
} from '../../common/js/common.js'
export default {
  name: 'newPaper',
  data() {
    return {
      imgs: [],
      selectPicsNum: 0,
      gobalUrl: config.gobalUrl,
      userInfo: JSON.parse(sessionStorage.userInfo),
      openID: JSON.parse(sessionStorage.userInfo).openId,
      myCoupons: [],
      myWelfares: [],
      page: 1,
      pageSize: 20,
      selectedCoupons: [],
      selectedWelfares: [],
      paperContent: '',
      uploadDisable: false,
      selectImgLength: 0



    }
  },
  created() {
    this.getCoupons()
    this.getMyWelfares()
  },
  methods: {
    selectPics(e) {
      let file = (e.target.files)
      this.selectImgLength += file.length
      this.uploadDisable = true;
      let maxSize = 1 * 1024 * 1024; //最大为2M
      this.imageLoop = true;
      for (let fileType in file) {
        //this.imageLoop = false
        if (!isNaN(fileType)) {
          if (['jpeg', 'png', 'jpg'].indexOf(file[fileType].type.split("/")[1]) < 0) {
            console.log("图片格式不对")
            return;
          }

          if (file[fileType].size < maxSize) { //图片小鱼2M
            var data = new FormData()
            let quality = 1
            this.compress(file[fileType], fileType, file[fileType].name, quality)
            this.selectPicsNum++

          } else { //图片大于2M
            let quality = Math.floor(maxSize / file[fileType].size * 10) / 10
            this.compress(file[fileType], fileType, file[fileType].name, quality)
            this.selectPicsNum++
          }



        }
      }

    },
    delPic(index) {
      this.imgs.splice(index, 1)
    },
    uploadImg(data) {
      //上传图片函数
      if (this.selectPicsNum > 9) {
        return;
      }
      this.$ajax.autoService.postLogin('api/uploadPosterPic.php', data).then((res) => {


        this.imgs.push("images/sg_" + res.data + '.jpg')
        if (this.selectImgLength == this.imgs.length) {
          this.uploadDisable = false
        }

      })
    },
    compress(file, fileType, name, quality) { //用canvas压缩
      var self = this,
        orientation;
      var image = new Image(),
        canvas = document.createElement("canvas"),
        ctx = canvas.getContext('2d');
      var reader = new FileReader();
      //获取图像信息

      EXIF.getData(file, function() {
        orientation = EXIF.getTag(this, 'Orientation')
      })
      reader.onload = function() {
        var url = this.result; //读取到的文件内容.这个属性只在读取操作完成之后才有效,并且数据的格式取决于读取操作是由哪个方法发起的.所以必须使用reader.onload
        image.src = url;
      }
      reader.readAsDataURL(file);
      image.onload = function() {
        var w = image.naturalWidth,
          h = image.naturalHeight;


        if (orientation == 6) {
          var minW  = Math.min(w,h)//canvas旋转的时候，宽跟高都是短的那边，防止canvas有黑色背景
          canvas.width = minW;
          canvas.height = minW;
          ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);

          var canvas_w = Number(ctx.canvas.width);
          var canvas_h = Number(ctx.canvas.height);
          ctx.save(); //保存状态
          ctx.translate(canvas_w / 2, canvas_h / 2); //设置画布上的(0,0)位置，也就是旋转的中心点
          ctx.rotate(90 * Math.PI / 180); //把画布旋转90度
          // 执行Canvas的drawImage语句

          ctx.drawImage(image,-canvas_h / 2,-canvas_w / 2); //把图片绘制在画布translate之前的中心点，
          ctx.restore(); //恢复状态

        } else {
          canvas.width = w;
          canvas.height = h;
          ctx.fillStyle = "#fff";
        ctx.fillRect(0, 0, canvas.width, canvas.height);

          ctx.drawImage(image, 0, 0, w, h, 0, 0, w, h);
        }

        var data = canvas.toDataURL("image/jpeg", quality);
        var datadata = data.split(',')[1];
        data = window.atob(datadata);

        var ia = new Uint8Array(data.length);
        for (var i = 0; i < data.length; i++) {
          ia[i] = data.charCodeAt(i);
        };
        //canvas.toDataURL 返回的默认格式就是 image/png
        var blob = new Blob([ia], {
          type: "image/jpeg"
        });
        var dataCanvas = new FormData();
        dataCanvas.append('file', blob, name);
        dataCanvas.append('id', (new Date()).getTime() + '_' + fileType)

        self.uploadImg(dataCanvas)



      };



      //that.imageUrl = data

      //dataURL 的格式为 “data:image/png;base64,****”,逗号之前都是一些说明性的文字，我们只需要逗号之后的就行了


    },
    getCoupons() { //获取优惠券
      this.$ajax.autoService.
      login("api/getMyCoupons.php?page=" + this.page + "&pageSize=" + this.pageSize + "&openid=" + this.openID).then((res) => {
        this.myCoupons = this.myCoupons.concat(res.data.map(function(item) {
          item.selected = false
          return item
        }))
      })
    },
    getMyWelfares() { //获取福利券
      this.$ajax.autoService.
      login("api/getMyWelfares.php?page=" + this.page + "&pageSize=" + this.pageSize + "&openid=" + this.openID).then((res) => {
        console.log(res)
        this.myWelfares = this.myWelfares.concat(res.data.map(function(item) {

          item.selected = false
          return item
        }))
      })
    },
    selectedCouponParent(index) { //选择优惠券
      this.myCoupons[index].selected = !this.myCoupons[index].selected;
      this.selectedCoupons.push(this.myCoupons[index].id_goods)
    },
    selectedWelfareParent(index) { //选择福利券
      this.myWelfares[index].selected = !this.myWelfares[index].selected;
      this.selectedWelfares.push(this.myWelfares[index].welfareid)

    },
    send() {
      if (this.paperContent.trim() == "" && this.imgs.length == 0) {
        Toast({
          message: "内容为空"
        })
      } else {
        let data = {
          senderOpenid: this.openID,
          content: this.paperContent,
          pics: this.imgs.toString(),
          selectedCoupons: this.selectedCoupons,
          selectedWelfares: this.selectedWelfares
        }
        this.$ajax.autoService.
        postData('api/addPaper.php', data).then((res) => {
          console.log(res.data)
          if (res.data && res.data > 0) {
            Toast({
              message: "发表成功"
            })
          }
          addScore('晒单', this.openID, function(score) {

          })
          this.$router.push('/quan')
        })

      }
    }

  },
  components: {
    'baskCoupons': BaskCoupons,
    'baskWelfare': BaskWelfare
  }
}
</script>
<style lang="stylus">
  .user_wrapper
    width: 100%
    box-sizing: border-box
    padding: 15px 30px
    display: flex
    justify-content: space-between
    background: #fff
    border-bottom: 1px solid #e5e5e5
    /*px*/
    .avatarUrlPic
      width: 64px
      height: 64px
      border-radius: 50%
      vertical-align: middle
      margin-right: 10px
    .userName
      display: inline-block
      height: 64px
      line-height: 64px
      font-size: 24px
      color: #333
    .publish_btn_wrapper
      width: 120px
      height: 50px
      line-height: 50px
      color: #fff
      font-size: 30px
      background: #ffc333
      border-radius: 25px
      display:inline-block
      line-height:50px
      text-align:center
  .publish_wrapper
    padding: 30px 30px 50px
    background: #fff
    margin-top: 15px
    box-sizing: border-box
    .paperContent
      width:100%
      padding: 5px
      font-size: 30px
      color: #333
      height:240px
      box-sizing:border-box
      outline:none
    .upload_img_wrapper
      padding: 10px 5px
      .picItem
        width: 170px
        height: 170px
        margin: 0 5px 10px
        border-radius: 15px
        display: inline-block
        position: relative
        vertical-align:middle
        .goods_pic
          width: 170px
          height: 170px
          border-radius: 15px
        .delete_wrapper
          width: 170px;
          height: 60px;
          background: rgba(0,0,0,0.45)
          position: absolute
          left: 0px
          bottom: 0px;
          text-align: center
          line-height: 60px
          border-radius:0 0 15px 15px
          .icon_delete_clor
            color: #fff
      .upload_btn_wrapper
        width: 170px
        height: 170px
        margin: 0 5px 10px
        border-radius: 15px
        display: inline-block
        background: #f5f5f5
        position: relative
        vertical-align:middle
        .upload_btn
          position: absolute
          left: 50%
          top: 50%
          transform: translate(-50%,-50%)
          line-height: 43px
          .upload_btn_text
            font-size: 28px
            color: #222
            margin-top: 10px
          .upload_btn_img
            width: 55px
            height: 43px
        .uploader
          width: 170px
          height: 170px
          position:absolute
          left:0px
          top:0px
          opacity:0
        .upload_disable
          width: 170px
          height: 170px
          position:absolute
          left:0px
          top:0px
          background:#20293a
          border-radius: 15px
          text-align:center
          line-height:170px
          color:#fff;
          font-size:30px
          animation: text 10s ease infinite
          @keyframes text {
            0% {
              color: #7400f9;
            }
            50% {
              color: #00fcbd;
            }
            100% {
              color: #7400f9;
            }
          }




</style>



// WEBPACK FOOTER //
// src/components/quan/newPaper.vue